import { Grid, Typography } from '@mui/material';
import { StyledSelect } from '@tassat/formik-input';
import * as React from 'react';

import muiStyles from './styles';
import { RecordsPerPageSelectorProps } from './types';

interface SelectOption {
    label: number;
    value: number;
}

export default function RecordsPerPageSelector(props: RecordsPerPageSelectorProps) {
    const {
        currentRecordsPerPage,
        setRecordsPerPage
    } = props;

    const classes = muiStyles(props);
    const defaultOptions: SelectOption[] = [
        {
            label: 50,
            value: 50
        },
        {
            label: 100,
            value: 100
        },
        {
            label: 150,
            value: 150
        }
    ];

    return (
        <Grid
            className={classes.root}
            container
            direction='row'
            spacing={0}
        >
            <StyledSelect
                className={classes.itemsSelect}
                menuPosition='fixed'
                onChange={(selectedOption) => {
                    setRecordsPerPage(selectedOption?.value);
                }}
                options={defaultOptions}
                value={defaultOptions.find((opt) => opt.value === currentRecordsPerPage)}
            />
            <Typography
                className={classes.itemsText}
                variant='body2'
            >Items per page
            </Typography>
        </Grid>
    );
}